import { render, staticRenderFns } from "./informationBox.vue?vue&type=template&id=2535e1f7&"
import script from "./informationBox.vue?vue&type=script&lang=js&"
export * from "./informationBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports